module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-panel', {
    attrs: {
      "title": "用户评价"
    }
  }, [_c('ul', _vm._l((_vm.messages), function(message) {
    return _c('li', [_c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "user"
    }, [_vm._v(_vm._s(message.user))]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(message.date))])]), _vm._v(" "), _c('p', {
      staticClass: "message"
    }, [_vm._v(_vm._s(message.message))])])
  }))]), _vm._v(" "), (_vm.allMessages.length > 4) ? _c('div', {
    staticClass: "footer"
  }, [_c('span', {
    staticClass: "more",
    class: {
      'more--active': !_vm.showMoreState
    },
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v(_vm._s(_vm.moreTips))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-741a2872"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Message.vue
// module id = 660
// module chunks = 1